import { ProductRecommendationRepository } from '../repositories/product-recommendation';

export class DependenciesService {
  static create() {
    return new DependenciesService(window.e.utils, ProductRecommendationRepository.create());
  }

  constructor(uiKitUtils, productRecommendationRepository) {
    this._uiKitUtils = uiKitUtils;
    this._productRecommendationRepository = productRecommendationRepository;
  }

  async load() {
    const [{ customerId, flippers, features }, jwt, translations] = await Promise.all([
      this._loadConfig(),
      this._loadJwt(),
      this._loadTranslations()
    ]);

    const productSources = await this._productRecommendationRepository.fetchSources(customerId, jwt);

    return {
      customerId,
      flippers,
      features,
      jwt,
      translations: translations['product-source-selector-dialog'],
      productSources: this._filterProductSources(productSources, flippers, features)
    };
  }

  _loadConfig() {
    return this._uiKitUtils.getConfig();
  }

  async _loadJwt() {
    return await this._uiKitUtils.getAuthenticationToken('product-recommendation');
  }

  _loadTranslations() {
    return this._uiKitUtils.getTranslation('product-source-selector-dialog');
  }

  _filterProductSources(productSources, flippers, features) {
    if (!features.includes('rti_product_catalog_updates')) {
      productSources = productSources.filter(
        productSource => productSource.id !== 'price_drop' && productSource.id !== 'back_in_stock'
      );
    }

    if (!features.includes('rti_advanced_features')) {
      productSources = productSources.filter(productSource => productSource.id !== 'abandoned_cart');
    }

    if (!features.includes('rti_product_catalog_updates')) {
      productSources = productSources.filter(productSource => productSource.id !== 'low_in_stock');
    }

    if (!features.includes('wishlist')) {
      productSources = productSources.filter(productSource => productSource.type !== 'ems_wishlist');
    }

    if (!features.includes('personalization_rules')) {
      productSources = productSources.filter(productSource => productSource.type !== 'product_segment');
    }

    if (!flippers.includes('personalization_enable_order_confirmation_product_source')) {
      productSources = productSources.filter(productSource => productSource.id !== 'order_confirmation');
    }

    return productSources;
  }
}
